<template lang="pug">
  .component.component-backoffice-driver-notes
    span(v-if="type==='noteCard'" )
      ModalReveal.p-0.m-0
        a.pr-2.fa.fa-comment.fa-lg(slot="trigger")
          span.badge.success(v-if="notes > 0" ) {{notes}}

        label Add note
          form(@submit.prevent="pushNote")
            input(type="text", v-model="body.description")
          ActionButton(:action="pushNote") Add
        h2 Notes
        base-list(:component="component", :dataLoader="dataLoader", :showPerPageSelect="false", ref="baseList", componentType="table")
    .div(v-if="type==='highlightedNotes'" )


</template>
<script type="text/babel">
import {mapState} from 'vuex'
import ModalReveal from "../structure/foundation/ModalReveal";
import LoadingSpinner from "../structure/LoadingSpinner";
import KeplerBackofficeSdk from "../../lib/kepler/backoffice";
import BaseList from "../../pages/backoffice/BaseList";
import ActionButton from "../structure/ui/ActionButton";

export default {
  name: 'DriverNotes',
  components: {
    ActionButton,
    BaseList,
    LoadingSpinner,
    ModalReveal

  },
  data() {
    return {
      body: {
        description: null,
        id: this.driver_id,
        type: 'App\\Models\\Driver'
      },
      loading: false,
      component: require('src/components/backoffice/Note'),
      notes: 0,
      items: null
    }
  },
  created() {
    this.dataLoader((notes) => {
      this.notes = notes.items_count
    })
  },
  methods: {
    dataLoader(callback, page = 1, resultsPerPage = 25) {
      KeplerBackofficeSdk.notes.list().all({
        per_page: resultsPerPage,
        page_number: page,
        type: this.body.type,
        id: this.body.id
      }, (data) => {
        if(this.type === "highlightedNotes") {
          const new_obj = Object.assign(data, {'highlightedNotes' : true});
          this.items = new_obj
          this.$emit('notes', this.items)
        }
        callback(data)
      })
    },
    pushNote() {
      const body = {...this.body}
      body.description += `\n -  (${this.user.username})`

      this.body.description = null
      this.$refs.baseList.data.items = null
      return KeplerBackofficeSdk.notes.make(body, () => this.$refs.baseList.loadData(1)).finally(() => this.loading = false)
    }
  },
  computed: {
    ...mapState({
      configuration: state => state.configuration,
      user: state => state.userStore.user
    }),

  },
  props: {
    driver_id: {
      required: true
    },
    type: {
      type: String,
      default: ''
    }
  },
}
</script>
<style lang="sass" rel="stylesheet/sass">
.component.component-backoffice-driver-notes
  .description
    white-space: pre
</style>



// WEBPACK FOOTER //
// DriverNote.vue?2e6ce1a3